import React from 'react';
import './ConsultingHome.css';

const ConsultingHome = () => {
  return (
    <div className="consulting-page">
      {/* Hero Section */}
      <section className="consulting-hero">
        <div className="consulting-container">
          <h1 className="consulting-title">
            Early Career Consulting for High School, College Students, and Early Career Professionals
          </h1>
          <p className="consulting-subtitle">
            I help high school and college students level up early-career outcomes by giving them practical systems for internship prep, networking, and interviews.
          </p>
          <a href="#booking" className="consulting-cta-btn">
            Get Started Today
          </a>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="consulting-who-we-are">
        <div className="consulting-container">
          <div className="who-we-are-content">
            <h2 className="section-heading text-center">Who We Are</h2>
            <p className="who-we-are-text">
              TQS Consulting is built on firsthand experience navigating elite consulting and AI careers. Led by Myles Thomas, a Forward Deployed AI Engineer at BCG X and ex-McKinsey consultant, we bring a practical, systems-based approach to recruiting.
            </p>
            <p className="who-we-are-text">
              As a non-target student, Myles broke into MBB by learning that top-tier offers require more than a strong GPA—they demand strategic networking, a bulletproof resume, and elite interview skills. Today, TQS helps students and early-career professionals bypass the guesswork, applying proven, data-driven systems to turn effort into competitive opportunities and real job offers.
            </p>
          </div>
        </div>
      </section>

      {/* Services Breakdown */}
      <section className="consulting-services">
        <div className="consulting-container">
          <h2 className="section-heading text-center">What We Offer</h2>
          
          {/* Toggle this variable to true/false to switch between centered and left-aligned text in the cards */}
          {(() => {
            const isCentered = true;
            return (
              <div className={`services-grid ${isCentered ? 'services-centered' : ''}`}>
                <div className="service-column">
                  <div className="service-icon">🏫</div>
                  <h3>College Students / Professionals</h3>
                  <ul className="service-list">
                    <li><strong>Job Applications</strong></li>
                    <li>Resume reviews/re-writes</li>
                    <li>Finding relevant job postings</li>
                    <li>Working with headhunters</li>
                    
                    <li className="mt-3"><strong>Networking</strong></li>
                    <li>Cold outreach templates</li>
                    <li>Target company lists</li>
                    <li>Referral strategy</li>
                    
                    <li className="mt-3"><strong>Mock Interviews</strong></li>
                    <li>McKinsey-style consulting interviews</li>
                    <li>Technical/leetcode-style tech interviews</li>
                    <li>Behavioral & STAR method coaching</li>
                    
                    <li className="mt-3"><strong>Story Building</strong></li>
                    <li>Crafting your personal narrative</li>
                    <li>Building an interview story bank</li>
                  </ul>
                </div>

                <div className="service-column">
                  <div className="service-icon">🎓</div>
                  <h3>High School</h3>
                  <ul className="service-list">
                    <li><strong>What to major in</strong></li>
                    <li>Picking a major with purpose</li>
                    <li>Choosing High ROI Majors</li>
                    
                    <li className="mt-3"><strong>College Admissions</strong></li>
                    <li>College application essay</li>
                  </ul>
                </div>
              </div>
            );
          })()}
        </div>
      </section>

      {/* ICP / Who We Serve */}
      <section className="consulting-icp">
        <div className="consulting-container">
          <h2 className="section-heading text-center">Who We Serve</h2>
          <div className="icp-grid">
            <div className="icp-card">
              <h4>High School Students</h4>
              <p>Grades 10-12 exploring majors and future careers.</p>
            </div>
            <div className="icp-card">
              <h4>College Students</h4>
              <p>Undergraduates needing direction, internships, or actively applying for full-time roles.</p>
            </div>
            <div className="icp-card">
              <h4>Early Career Professionals</h4>
              <p>Recent graduates and young professionals navigating career transitions or lateral moves.</p>
            </div>
            <div className="icp-card">
              <h4>Parents</h4>
              <p>Parents who want structure and accountability for their student.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Service Section */}
      <section className="consulting-core-service">
        <div className="consulting-container">
          <div className="core-service-card">
            <span className="flagship-label">CORE OFFERING</span>
            <h2 className="section-heading" style={{ marginTop: '0.5rem', marginBottom: '1rem' }}>Internship Prep Sprint</h2>
            <p className="core-blurb">
              My flagship program. An intensive, action-oriented sprint designed to help you land your next role.
            </p>
            
            <div className="core-details">
              <div className="core-includes">
                <h3>What You Walk Away With:</h3>
                <ul>
                  <li>A resume that passes real recruiter screens</li>
                  <li>A target list of 10–50 companies + exactly who to contact</li>
                  <li>30+ cold messages sent</li>
                  <li>1–3 completed mock interviews with feedback</li>
                  <li>A ready-to-use interview story bank</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Section */}
      <section id="booking" className="consulting-booking">
        <div className="consulting-container">
          <h2 className="section-heading text-center">Book a Consultation</h2>
          <p className="text-center booking-subtitle">
            Find a time that works for you. I'm available every day of the week, 8:00 AM - 6:00 PM CT.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;For availability outside these hours, please email <a href="mailto:tqstrats@gmail.com">tqstrats@gmail.com</a>.
          </p>
          <div className="booking-embed-container" style={{ height: '700px', width: '100%' }}>
            <iframe 
              src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3yV_skKcN2cqGQKbe02qiingwCnvzGGxL5GOXs_EcKKvM1vEXTDJLw4PO4RC4BnX-CTsXpM9xP?gv=true" 
              style={{ border: 0, width: '100%', height: '100%' }} 
              frameBorder="0"
              title="Book a consultation"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConsultingHome;
